var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-top'),_vm._v(" "),_c('div',{staticClass:"container-fluid app-wrapper"},[_c('div',{staticClass:"row flex-xl-nowrap"},[_c('main',{staticClass:"p-3 col-12",attrs:{"role":"main"}},[_vm._t("default")],2)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('pre',{staticClass:"text-right text-muted px-4"},[_vm._v(" v"+_vm._s(_vm.version)+" ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3cb297","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/default.vue
// module id = null
// module chunks = 